import { useEffect } from "react";
import { Gift, UserCheck, UserPlus } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { RewardPicker } from "@/components/loyalty/RewardPicker";
import { api, brl, digits } from "@/lib/api";
import { rewardSummary } from "@/lib/loyalty";

export const NO_REDEEM = { use: false, sel: [], freeDel: false };

export function loyaltyCalc(known, r, subtotal, fee) {
  const l = known?.found && known.loyalty;
  if (!l?.enabled) return { off: 0, deliveryOff: 0, products: [] };
  if (l.mode === "cashback") return { off: r.use ? Math.min(l.balance, Math.max(0, subtotal)) : 0, deliveryOff: 0, products: [] };
  const s = rewardSummary(l, r.sel, r.freeDel, fee);
  return { off: Math.min(s.discount, Math.max(0, subtotal)), deliveryOff: s.deliveryOff, products: s.products };
}

function Cashback({ l, redeem, setRedeem }) {
  if (l.balance <= 0) return <p className="text-xs text-muted-foreground" data-testid="order-loyalty-none">Ainda sem cashback para usar.</p>;
  return (
    <label className="flex items-center justify-between gap-3" data-testid="order-loyalty-box">
      <span className="flex items-center gap-2"><Gift className="h-4 w-4 text-primary" />Tem <b>{brl(l.balance)} de cashback</b>. Usar nesta compra?</span>
      <Switch checked={redeem.use} onCheckedChange={(v) => setRedeem((x) => ({ ...x, use: v }))} data-testid="order-use-loyalty-switch" />
    </label>
  );
}

export function OrderCustomerBox({ phone, known, setKnown, onFound, redeem, setRedeem, allowFreeDelivery }) {
  const d = digits(phone);
  useEffect(() => {
    setRedeem(NO_REDEEM);
    if (d.length < 10) { setKnown(null); return undefined; }
    const t = setTimeout(() => {
      api.get("/orders/customer-lookup", { params: { phone } }).then(({ data }) => {
        setKnown(data);
        if (data.found) onFound(data.customer);
      }).catch(() => setKnown(null));
    }, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [d]);
  if (d.length < 10) return <p className="text-xs text-muted-foreground" data-testid="order-customer-hint">Informe o telefone com DDD para cadastrar o cliente e ver os pontos dele.</p>;
  if (!known) return null;
  if (!known.found) {
    return <p className="flex items-center gap-2 rounded-lg border border-dashed px-3 py-2 text-xs text-muted-foreground" data-testid="order-customer-new"><UserPlus className="h-4 w-4" />Cliente novo: será cadastrado automaticamente ao criar o pedido.</p>;
  }
  const l = known.loyalty;
  const setSel = (fn) => setRedeem((x) => ({ ...x, sel: typeof fn === "function" ? fn(x.sel) : fn }));
  return (
    <div className="space-y-2 rounded-lg border border-emerald-500/30 bg-emerald-500/5 px-3 py-2 text-sm" data-testid="order-customer-known">
      <p className="flex items-center gap-2 font-medium text-emerald-600 dark:text-emerald-400"><UserCheck className="h-4 w-4" />Cliente cadastrado: {known.customer.name}</p>
      {!l.enabled ? <p className="text-xs text-muted-foreground" data-testid="order-loyalty-none">Programa de fidelidade desligado.</p>
        : l.mode === "cashback" ? <Cashback l={l} redeem={redeem} setRedeem={setRedeem} />
          : <RewardPicker wallet={l} sel={redeem.sel} setSel={setSel} freeDel={redeem.freeDel} setFreeDel={(v) => setRedeem((x) => ({ ...x, freeDel: v }))} allowFreeDelivery={allowFreeDelivery} />}
    </div>
  );
}
